<template>
  <div v-if="loaded" class="pointer">
    <div>
      <h4 class="inline">PICKED FOR {{ storeName }}</h4>
      <a class="regular">
        {{ countMessage }}
      </a>
    </div>
    <div class="page-header--wrapper grid-12 grid-column-gap-28 mb-50-md">
      <div class="span-6 span-12-sm mb-30-sm grid-column-gap-28">
        <img v-if="thumbList[0]" :src="thumbList[0]" class="width-100 h-100" alt="" />
        <div v-else class="width-100 h-100 placeholder" alt="" />
      </div>
      <div class="span-3 span-6-sm">
        <img v-if="thumbList[1]" :src="thumbList[1]" class="width-100 h-half h-bumper" alt="" />
        <div v-else class="width-100 h-half h-bumper placeholder" alt="" />

        <img v-if="thumbList[2]" :src="thumbList[2]" class="width-100 h-half" alt="" />
        <div v-else class="width-100 h-half placeholder" alt="" />
      </div>
      <div class="span-3 span-6-sm">
        <img v-if="thumbList[3]" :src="thumbList[3]" class="width-100 h-half h-bumper" alt="" />
        <div v-else class="width-100 h-half h-bumper placeholder" alt="" />

        <img v-if="thumbList[4]" :src="thumbList[4]" class="width-100 h-half" />
        <div v-else class="width-100 h-half placeholder" alt="" />
      </div>
    </div>
  </div>
</template>
<script>

import {algoliaBaseHelper} from "../../../components/mixin/search/algoliaBaseHelper";

export default {
  name: "ThumbnailSection",
  mixins: [algoliaBaseHelper],
  props: ["ids", "type", "storeName"],
  data: function () {
    return {
      loaded: false,
      count: null,
      thumbList: [null, null, null, null, null],
    };
  },
  computed: {
    countMessage: function () {
      return `(${this.count} brand${this.count === 1 ? "" : "s"})`;
    },
  },
  mounted() {
    const brandIndex = this.$env.getOrigin() + "_brands";
    this.algoliaClient
      .initIndex(brandIndex)
      .getObjects(this.ids)
      .then(({ results }, err) => {
        if (err) {
          return;
        }
        const brandsListData = results;
        this.count = brandsListData.length;
        this.thumbList = this.thumbList.map((productSlot, i) => {
          if (brandsListData[i]) {
            return brandsListData[i].thumbnail_image_url;
          }
          return false;
        });
        this.loaded = true;
      });
  },
};
</script>
<style lang="scss" scoped>
.h-100 {
  min-height: 470px;
  max-height: 490px;
}
.h-half {
  height: 47%;
}
.h-bumper {
  margin-bottom: 14%;
}
img {
  object-fit: cover;
  -o-object-position: center;
  object-position: center;
}
.placeholder {
  background-color: #f5f5f5;
}
</style>
